import { Toggle as ArkToggle } from '@ark-ui/react';

import { cn } from '../../lib/utils';

function ToggleRoot({ className, ...props }: ArkToggle.RootProps) {
	return <ArkToggle.Root className={cn('pt-toggle', className)} {...props} />;
}

function ToggleIndicator({ className, ...props }: ArkToggle.IndicatorProps) {
	return <ArkToggle.Indicator className={cn('pt-toggle-indicator', className)} {...props} />;
}

const Toggle = {
	Root: ToggleRoot,
	Indicator: ToggleIndicator,
	Context: ArkToggle.Context
};

export { Toggle };
